<div class="card mt-4">
  <h4 class="card-header card-title">{{ settings.title || 'Analytics Line Chart' }}</h4>
  <div class="card-body">
    <div *ngIf="settings.subtitle">{{ settings.subtitle }}</div>
    <div>{{ formatDuration() }}</div>
    <app-analytics-graph
      type="line"
      [metric]="settings.metric"
      [defaultGrouping]="settings.grouping || 'date'"
      [defaultDatasets]="settings.datasets || []"
      [from]="settings.from"
      [to]="settings.to"
      [filter]="settings.filter"
      [exclude]="settings.exclude"
      [relative]="settings.relative"
      [labelNames]="settings.labelNames"
    >
    </app-analytics-graph>
  </div>
</div>
